export function addMonthsISO(dateStr, months = 1) {
  const s = String(dateStr || '').slice(0, 10);
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) {
    const now = new Date();
    now.setMonth(now.getMonth() + months);
    return now.toISOString().slice(0, 10);
  }
  const next = new Date(y, m - 1 + months, d);
  if (next.getDate() !== d) {
    next.setDate(0);
  }
  const yy = next.getFullYear();
  const mm = String(next.getMonth() + 1).padStart(2, '0');
  const dd = String(next.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

export function normalizeRecurringFrequency(raw) {
  const f = String(raw || 'monthly').toLowerCase();
  if (f === 'annual' || f === 'anual') return 'yearly';
  if (f === 'yearly') return 'yearly';
  return 'monthly';
}

export function defaultNextRun(fromDate, frecuencia = 'monthly') {
  const months = normalizeRecurringFrequency(frecuencia) === 'yearly' ? 12 : 1;
  return addMonthsISO(fromDate || new Date().toISOString().slice(0, 10), months);
}

export function recurringFrequencyLabel(frecuencia) {
  return normalizeRecurringFrequency(frecuencia) === 'yearly' ? 'anual' : 'mensual';
}

export async function runDueRecurring(secureFetch) {
  try {
    const res = await secureFetch('/api/recurring/run-due', { method: 'POST' });
    if (!res.ok) return { generated: 0 };
    const data = await res.json();
    return {
      generated: Number(data.generated) || 0,
      skipped: Number(data.skipped) || 0,
      failed: Number(data.failed) || 0,
    };
  } catch {
    return { generated: 0 };
  }
}
